import {Component, OnInit, HostListener, OnDestroy} from '@angular/core';
import {PhoneTransformer} from '../../../services/transformer.service';
import {ManagementCompanyService} from './services/management-company.service';
import {Company, Office} from '../../../types/admin-data.types';
import {UrlService} from '../../../services/url.service';
import {flatMap, takeUntil} from 'rxjs/operators';

@Component({
    templateUrl: './management-company.component.html',
    styleUrls: ['./management-company.component.scss']
})
export class ManagementCompanyComponent implements OnInit, OnDestroy {
    public isShowView: boolean = false;
    public viewedItem: Company;
    public selectedOffice: Office;
    public isCreateNew: boolean = false;
    public isShowAddOffice: boolean = false;

    constructor(public urlService: UrlService,
                public managementCompany: ManagementCompanyService) {
    }

    ngOnInit() {
        this.managementCompany.urlService
            .onUrlChange
            .pipe(
                flatMap(() => this.managementCompany.getCompaniesByQueryParams().pipe(takeUntil(this.urlService.instantOnUrlChange)))
            )
            .subscribe();
        this.managementCompany.urlService.setQueryParams('companies');
        this.managementCompany.getAllThemes();
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.managementCompany.urlService.resetQueryParams();
        this.managementCompany.companies = [];
        this.isShowView = false;
    }

    removeItem() {
        this.managementCompany.remove(this.viewedItem.id).subscribe(() => {
            this.closeDetails();
        });
    }

    toggleDetails(item: Company): void {
        this.isShowView = this.managementCompany.toggleCheckCompany(item);
        if (this.isShowView) {
            this.viewedItem = item;
        }
    }

    closeDetails(): void {
        this.isShowView = false;
        this.urlService.modalClosed.emit();
    }

    createNew(): void {
        this.isCreateNew = true;
    }

    closeCreateNew(): void {
        this.isCreateNew = false;
        this.urlService.modalClosed.emit();
    }

    showAddOffice(data?: Office): void {
        this.selectedOffice = data || new Office();
        this.isShowAddOffice = true;
    }

    removeOffice(office: Office): void {
        this.managementCompany.deleteOffice(office, this.updateOfficeView.bind(this));
    }

    closeAddOffice(): void {
        this.isShowAddOffice = false;
        this.urlService.modalClosed.emit();
    }

    updateOfficeView(): void {
        this.managementCompany.getCompanies(this.viewedItem.id, (updatedItem) => this.viewedItem = updatedItem);
    }

    removeAllObservers() {
        this.managementCompany.urlService.onUrlChange.observers = [];
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.managementCompany.emptyRowService.fillEmptyRow();
    }

    formatPhone(phone: string) {
        return PhoneTransformer.stringToPhone(phone);
    }
}






// WEBPACK FOOTER //
// /app/src/app/views/admin/management-company/management-company.component.ts